import React from 'react'
import PropTypes from "prop-types";
import UnlockIcon from './lock';


const TMLocked = ({ zoomFactor, lockedItems, workspaceStage }) => {
    const lockedObjects = lockedItems;
    const boundsArray = [];

    lockedObjects.forEach((lockedObject) => {
        const bounds = {
            x: lockedObject.get("x") * zoomFactor,
            y: lockedObject.get("y") * zoomFactor,
            width: lockedObject.get("width") * zoomFactor,
            height: lockedObject.get("height") * zoomFactor,
            angle: lockedObject.get("angle") || 0,
            id: lockedObject.get("id")
        }
        boundsArray.push(bounds);
    })

    return (
        <>
            {
                boundsArray.map((bounds) => {
                    return (
                        <>
                            <div className="locked-container" id={bounds.id} key={bounds.id} style={{
                                display: "block",
                                position: "absolute",
                                border: "2px solid #ffc423",
                                transform: `rotate(${bounds.angle}deg)`,
                                top: bounds.y,
                                left: bounds.x,
                                height: bounds.height,
                                width: bounds.width,
                            }}
                            />
                            <UnlockIcon
                                lockedObjects={lockedItems}
                                zoomFactor={zoomFactor}
                                workspaceStage={workspaceStage}
                            />
                        </>
                    )
                })
            }
        </>
    )
}

TMLocked.propTypes = {
    zoomFactor: PropTypes.string,
    lockedItems: PropTypes.object,
    workspaceStage: PropTypes.object,
};

export default TMLocked